import React from "react";
import menuClosed from "../images/icon/menu_open.svg";
import menuOpen from "../images/icon/menu_close.svg";
import quietOn from "../images/icon/quiet_mode_on.svg";
import quietOff from "../images/icon/quiet_mode_off.svg";

const Options = ({
  onMenu,
  onQuiet,
  menuStatus,
  quietStatus,
  currentIndex,
}) => {
  const handleMenuClick = (e) => {
    e.preventDefault();
    onMenu();
  };
  const handleQuietClick = (e) => {
    e.preventDefault();
    onQuiet();
  };

  const renderMenuIcon = () => {
    const menuIcon = menuStatus ? menuOpen : menuClosed;
    return menuIcon;
  };

  const renderQuietIcon = () => {
    const quietIcon = quietStatus ? quietOff : quietOn;
    return quietIcon;
  };

  const renderQuietText = () => {
    if (quietStatus) {
      return (
        <p className="quiet-text quiet-text--off">
          Quiet mode: <br /> Off
        </p>
      );
    } else {
      return (
        <p className="quiet-text quiet-text--on">
          Quiet mode: <br /> On
        </p>
      );
    }
  };

  const identifier = `${currentIndex.flow}-${currentIndex.section + 1}`;

  return (
    <div className="app-options__top">
      <button
        aria-label="menu toggle"
        className="menu-control"
        onClick={handleMenuClick}>
        <img alt="menu icon" src={renderMenuIcon()} />
      </button>
      <button
        aria-label="quiet mode toggle"
        className="quiet-control"
        onClick={handleQuietClick}
        data-identifier={identifier}>
        <img alt="icon with message bubble" src={renderQuietIcon()} />
      </button>
      {renderQuietText()}
    </div>
  );
};

export default Options;
